import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PendapatanProdukContent from "./PendapatanProdukContent";

const SalesPackagesPage = () => (
  <PendapatanProdukContent
    type="paket"
    title={translate("analyticsPage.package.report_pendapatan_produk")}
    backTo={PATHS.ANALYTICS}
  />
);

export default SalesPackagesPage;
